import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'reedle-dev-new-onboarding';
const CHANGE_EVENT = 'reedle-dev-new-onboarding-change';

function subscribe(onChange) {
  const onStorage = (event) => {
    if (event.key === STORAGE_KEY || event.key === null) onChange();
  };
  window.addEventListener(CHANGE_EVENT, onChange);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(CHANGE_EVENT, onChange);
    window.removeEventListener('storage', onStorage);
  };
}

function getSnapshot() {
  return localStorage.getItem(STORAGE_KEY) === 'true';
}

function setEnabled(enabled) {
  if (enabled) localStorage.setItem(STORAGE_KEY, 'true');
  else localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event(CHANGE_EVENT));
}

// A device-local preview preference, independent of account settings and sync.
export default function useNewOnboardingPreference() {
  const enabled = useSyncExternalStore(subscribe, getSnapshot, () => false);
  return [enabled, setEnabled];
}
